import { useQuery } from "react-query";
import axios from "infra/http";
import { DataParceiroForm } from "../typings";

function useParceiro(id: string) {
  return useQuery(
    [`/v1/parceiro/${id}`],
    async () => {
      
      const res = await axios.get<DataParceiroForm>(`/v1/parceiro/${id}`);
      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}
export default useParceiro;
